import { render } from "./formWizard.vue?vue&type=template&id=c41495a0&lang=true"
import script from "./formWizard.vue?vue&type=script&lang=js"
export * from "./formWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__